import React from 'react';
import { HouseLine, ArrowCounterClockwise, Archive, Buildings, X, Sparkle } from '@phosphor-icons/react';
interface FinalizedAnuntCardProps {
  succesCounterpartyName?: string;
  succesCounterpartySubRole?: 'proprietar' | 'agent';
  succesCounterpartyAgencyName?: string;
  succesAt?: string;
  succesListingTitle?: string;
  onCancel?: () => void;
  onViewArchive?: () => void;
  onClickCounterparty?: () => void;
  onDismiss?: () => void;
}
export function FinalizedAnuntCard({
  succesCounterpartyName,
  succesCounterpartySubRole,
  succesCounterpartyAgencyName,
  succesAt,
  succesListingTitle,
  onCancel,
  onViewArchive,
  onClickCounterparty,
  onDismiss
}: FinalizedAnuntCardProps) {
  const closedAt = succesAt ? new Date(succesAt).toLocaleDateString('ro-RO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }) : null;
  // ONE-paragraph copy (no repetition of "ai închiriat" three times)
  const renderCopy = () => {
    if (!succesCounterpartyName) {
      return 'Anunțul este închis. Restul ofertelor au fost arhivate automat.';
    }
    const nameNode = onClickCounterparty ? <button type="button" onClick={onClickCounterparty} className="font-medium text-light-1 hover:text-lime-1 transition-colors underline-offset-2 hover:underline" data-id="element-220">
        {succesCounterpartyName}
      </button> : <span className="font-medium text-light-1" data-id="element-221">{succesCounterpartyName}</span>;
    // Role-aware "cu / prin"
    let preposition: React.ReactNode = <>cu {nameNode}</>;
    if (succesCounterpartySubRole === 'agent') {
      if (succesCounterpartyAgencyName) {
        preposition = <>
            prin {nameNode} de la{' '}
            <span className="font-medium text-light-1" data-id="element-222">
              {succesCounterpartyAgencyName}
            </span>
          </>;
      } else {
        preposition = <>prin {nameNode}</>;
      }
    }
    return <>
        Anunțul este închis. Ai închiriat {preposition}. Restul ofertelor au
        fost arhivate automat.
      </>;
  };
  return <article className="rounded-2xl bg-dark-2 border border-lime-4 overflow-hidden relative" data-id="element-223">
      {onDismiss && <button type="button" onClick={onDismiss} className="absolute top-3 right-3 w-8 h-8 inline-flex items-center justify-center rounded-md text-light-3 hover:text-light-1 hover:bg-dark-3 transition-colors cursor-pointer" aria-label="Închide" title="Închide" data-id="element-224">
          <X size={16} weight="bold" data-id="element-225" />
        </button>}

      <div className="px-6 py-6 space-y-5 pr-12" data-id="element-226">
        <div className="flex items-start gap-4" data-id="element-227">
          <div className="w-12 h-12 rounded-2xl bg-lime-5 border border-lime-4 inline-flex items-center justify-center shrink-0" data-id="element-228">
            <Sparkle size={22} weight="fill" className="text-lime-1" data-id="element-229" />
          </div>
          <div className="min-w-0 flex-1" data-id="element-230">
            <h2 className="text-lg font-semibold text-light-1 leading-tight" data-id="element-231">
              Ai închiriat cu succes 🎉
            </h2>
            <p className="text-sm text-light-3 mt-2 leading-relaxed" data-id="element-232">
              {renderCopy()}
            </p>
          </div>
        </div>

        {(succesListingTitle || closedAt) && <div className="rounded-xl bg-dark-3 border border-dark-4 p-3 flex items-center gap-3" data-id="element-233">
            <div className="w-10 h-10 rounded-lg bg-dark-4 inline-flex items-center justify-center shrink-0" data-id="element-234">
              {succesCounterpartySubRole === 'agent' ? <Buildings size={18} className="text-light-2" data-id="element-235" /> : <HouseLine size={18} className="text-light-2" data-id="element-236" />}
            </div>
            <div className="min-w-0 flex-1" data-id="element-237">
              {succesListingTitle && <p className="text-sm font-medium text-light-1 truncate" data-id="element-238">
                  {succesListingTitle}
                </p>}
              {closedAt && <p className="text-xs text-light-3 mt-0.5" data-id="element-239">
                  Închis pe {closedAt}
                </p>}
            </div>
          </div>}

        <div className="flex flex-col sm:flex-row gap-2 pt-1" data-id="element-240">
          {onViewArchive && <button type="button" onClick={onViewArchive} className="w-full sm:flex-1 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-lime-1 hover:bg-lime-2 text-dark-1 text-sm font-semibold transition-colors cursor-pointer" data-id="element-241">
              <Archive size={16} weight="bold" data-id="element-242" />
              Vezi sesiunea arhivată
            </button>}
          {onCancel && <button type="button" onClick={onCancel} className="w-full sm:flex-1 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-dark-3 hover:bg-dark-4 border border-dark-4 text-light-2 text-sm font-medium transition-colors cursor-pointer" data-id="element-243">
              <ArrowCounterClockwise size={16} weight="bold" data-id="element-244" />
              Anulează finalizarea
            </button>}
        </div>

        <p className="text-xs text-light-4 leading-relaxed" data-id="element-245">
          Peste un an, te vom invita să lași un review. Asta îți va construi
          reputația pentru următoarea închiriere.
        </p>
      </div>
    </article>;
}